export default __webpack_public_path__ + "static/media/direct-inbox.72b736e4.svg";